export { default as DiscountBadgeRegular } from './DiscountBadgeRegular';
